var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEthicsLineFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.913 21.587A10.038 10.038 0 012 12.037C2 6.494 6.477 2 12 2s10 4.494 10 10.037c0 4.462-2.9 8.245-6.913 9.55a.884.884 0 00-.881-.84h-1.324v-2.658a.886.886 0 00-.588-.835v-6.102h4.409l-1.553 4.133h-.062a2.203 2.203 0 003.732.001l.007-.001-1.694-4.133h1.338c.325 0 .41-.453.106-.57l-6.283-2.437V6.968A.886.886 0 0012 5.248a.886.886 0 00-.294 1.72v1.177L5.423 10.58c-.303.118-.22.57.106.57h1.406l-1.553 4.134H5.32a2.202 2.202 0 003.732.001l.007-.001-1.693-4.133h4.34v6.102a.886.886 0 00-.588.835v2.657H9.794a.884.884 0 00-.881.841zm2.793-12.81v1.784h-4.6l4.6-1.783zm.588 1.784V8.778l4.6 1.783h-4.6zM12 6.576a.442.442 0 11.002-.884.442.442 0 01-.002.884zm-6.313 8.709l1.466-3.88 1.6 3.88H5.687zm9.767 0l1.467-3.88 1.6 3.88h-3.067z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthicsLineFill);
export default __webpack_public_path__ + "ce3ff158f7cd24b58894994ccb7bc33a.svg";
export { ForwardRef as ReactComponent };